import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { CustomPatientGroupsUpdateForm } from './CustomPatientGroupsUpdateForm';
import { CustomPatientGroupsUpdateAction } from './CustomPatientGroupsUpdateModal.actions';
import { CustomPatientGroupsUpdateFormLoader } from './CustomPatientGroupsUpdateForm.loader';
import { customPatientGroupsUpdateFormInitializer } from './CustomPatientGroupsUpdateForm.utils';

type CustomPatientGroupsUpdateModalProps = {
   patientGroupId: number;
   onClose: VoidFunction;
};

export const CustomPatientGroupsUpdateModal = (props: CustomPatientGroupsUpdateModalProps): JSX.Element => {
   return (
      <Modal title={translationKeys.updateCustomGroup} width={ModalWidth.NORMAL} testId={'customPatientGroupsUpdate'}>
         <CustomPatientGroupsUpdateFormLoader patientGroupId={props.patientGroupId}>
            {({ patientGroup }) => (
               <CustomPatientGroupsUpdateForm initializer={customPatientGroupsUpdateFormInitializer(patientGroup)}>
                  {({ handleSubmit, formState, setNotUniqueCustomPatientGroupNameError }) => (
                     <>
                        <CustomPatientGroupsUpdateAction
                           groupId={patientGroup.id}
                           onSuccess={props.onClose}
                           onPatientGroupAlreadyExistsFault={setNotUniqueCustomPatientGroupNameError}
                        >
                           {({ updateCustomPatientGroup }) => (
                              <ModalConfirmButton
                                 label={translationKeys.save}
                                 onClick={handleSubmit(updateCustomPatientGroup)}
                              />
                           )}
                        </CustomPatientGroupsUpdateAction>

                        <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </CustomPatientGroupsUpdateForm>
            )}
         </CustomPatientGroupsUpdateFormLoader>
      </Modal>
   );
};
